import * as React from 'react';
import { ComponentProps, ValidationProps, ValidationSummary } from 'ui';
import styles from './entry-log-panel.scss';

export interface EntryLogPanelProps extends ComponentProps {
  columns: number;
  children: any;
  validation?: ValidationProps;
  icon?: React.ReactNode;
  entryLogValues?: {
    egressTime?: Date | string | number;
    egressTimeRecordedBy?: { value: string | number; description?: string };
  };
  showLabelOnlyWhenEgressActive?: boolean;
  hideWhenNoEgress?: boolean;
}

const shouldRenderLabel = (props: EntryLogPanelProps, egressActive: boolean): boolean => {
  const labelVisible = !!props.label?.text && props.label?.visible !== false;
  return labelVisible && (!props.showLabelOnlyWhenEgressActive || egressActive);
};

export const EntryLogPanel: React.FC<EntryLogPanelProps> = (props: EntryLogPanelProps) => {

  const {
    componentId,
    validation,
    className,
    children,
    icon
  } = props;

  const egressActive = !!props.entryLogValues?.egressTime;

  if (props.hideWhenNoEgress && !egressActive) {
    return null;
  }

  const renderLabel = shouldRenderLabel(props, egressActive);

  return (
    <div className={`${styles.entryLogPanel} ${className || ''}`} id={componentId}>
      {renderLabel ? 
        <div className={styles.labelWrapper}>
          {icon ? <span className={`${styles.icon}`}>{icon}</span> : null}
          {<span className={`${styles.label} label`}>{props.label.text}</span>}
        </div> : null
      }
      <ValidationSummary validationError={validation}/>
        {children}
    </div>
  );
};
